import React, {Fragment, useState} from 'react';
import Navbar from '../nav-bar/nav-bar';
import authAPI from '../../api/auth';
import {Link, useHistory} from 'react-router-dom';
import './confirmation.scss';

export default function(){
    const [isTokenValid, setIsTokenValid] = useState();
    const [message, setMessage] = useState();
    const [status, setStatus] = useState();
    const history = useHistory();
    var href = window.location.href.split("/");
    //console.log("confirmation href",href);
    if(href[4] === 'confirmation'){
        authAPI.confirmation(href[5].toString()).then(result=>{
            //console.log("result",result)
            if(result.status === 200){
                history.push(`/login`);
            }
        }).catch(err =>{
            if(err.toString().includes(400)){
                setIsTokenValid(false);
                setStatus(400);
                setMessage('Your account already verified. Please click login to continue.')
            }
            else if(err.toString().includes(401)){
                setIsTokenValid(false);
                setStatus(401);
                setMessage('We were unable to find a user for this token. Please re-register.')
            }
            else if(err.toString().includes(404)){
                setIsTokenValid(false);
                setStatus(404);
                setMessage('We were unable to find a valid token. Your token may have expired.')
            }  
        })
    }
    return(
        <Fragment>
        <div className={'confirmation'}>
        <Navbar/>
        {!isTokenValid?
            <div className={'error-400'}>
              <h1>{status}</h1>
              <p>{message}</p>
            </div>
        :""
        }
        </div>
        </Fragment>   
    )
}